import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Swiper from "react-id-swiper";
import { API_ROOT } from "../../configs/env-vars";
import AsSeenInSingle from "../../components/brand-logo/AsSeenInSingle";
import SectionTitleSeven from "../../components/section-title/SectionTitleSeven";

const AsSeenInSlider = ({ spaceBottomClass, spaceTopClass }) => {
  const [asSeenInData, setAsSeenInData] = useState([]);

  useEffect(async () => {
    const result = await axios(`${API_ROOT}/images/as-seen-in/`)
    setAsSeenInData(result.data.results)
  }, []);

  const settings = {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      640: {
        slidesPerView: 3,
      },
      320: {
        slidesPerView: 2,
      },
    },
  };

  return asSeenInData && asSeenInData.length > 0 ? (
    <div
      className={`brand-logo-area ${
        spaceBottomClass ? spaceBottomClass : ""
      }  ${spaceTopClass ? spaceTopClass : ""}`}
    >
      <div className="container">
        <SectionTitleSeven
          titleText="Featured In..."
          positionClass="text-center"
          spaceClass="mb-50"
          borderClass="no-border"
        />
        
          <div className="brand-logo-active">
            <Swiper {...settings}>
              {asSeenInData.map((single, key) => {
                return (
                  <AsSeenInSingle
                    data={single}
                    key={key}
                    sliderClassName="swiper-slide"
                    spaceBottomClass="mb-30"
                  />
                );
              })}
            </Swiper>
          </div>
      </div>
    </div>
  ) : null;
};

AsSeenInSlider.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default AsSeenInSlider;
